"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNextApiProvider = void 0;
var react_1 = __importStar(require("react"));
var request_hooks_1 = require("./request-hooks");
/**
 * The url passed in can be a string or a function that will be passed the URL query params. This lets us set the url
 * dynamically when the uuids might live in the browser url.
 */
function resolveUrl(url, params) {
    if (typeof url === 'string') {
        return url;
    }
    return url(params);
}
/**
 * Create a set of hooks and context helpers to load a page-level resource. As this resource loads it will update
 * the page title. If it fails to load it will show an error overlay with details about the error.
 */
function createNextApiProvider(url) {
    var Context = (0, react_1.createContext)(undefined);
    /**
     * Get the current value of the provider
     */
    function useProviderValue() {
        var value = (0, react_1.useContext)(Context);
        if (!value) {
            throw new Error('Provider value is not available. Make sure you’ve set the provider');
        }
        return value;
    }
    /**
     * Call the Next API route and set the value on the context provider. This should be wrapped in a Suspense component
     * to render loading states and you should use an error boundary component to catch any errors thrown.
     */
    var Provider = function (props) {
        var children = props.children, variables = props.variables;
        var data = (0, request_hooks_1.useNextApiSubscription)(resolveUrl(url, variables || {}), {
            suspense: true,
        }).data;
        return react_1.default.createElement(Context.Provider, { value: data }, children);
    };
    return [Provider, useProviderValue, Context];
}
exports.createNextApiProvider = createNextApiProvider;
